import React, {useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {useAuth } from '../../../../../auth'
import { getResetPasswordKey, getUserByToken, update_account } from '../../../../../auth/core/_requests'
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'

const profileDetailsSchema = Yup.object().shape({
  fName: Yup.string().required('First name is required'),
  lName: Yup.string().required('Last name is required'),
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required')
})

const ProfileDetails: React.FC = () => {
  const {logout, saveAuth, setCurrentUser, currentUser} = useAuth()
  const [loading, setLoading] = useState(false)
  const [encoded_id, setEncodedID] = useState(undefined)

  try {
    if(encoded_id == undefined){
      getResetPasswordKey().then((response)=>{
        setEncodedID(response.data)
      })
    }
  } catch (error) {
    console.error(error)
  }

  const initialValues = {
    fName: currentUser?.first_name,
    lName: currentUser?.last_name,
    email: currentUser?.email
  }

  function redirectToHome(){
    window.location.href = "/home";
  }

  const formik = useFormik({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        setSubmitting(false)
        setLoading(false)
        await update_account(currentUser?.id, values.fName, values.lName, values.email)
        Swal.fire({
            title: 'Success!',
            text: 'ทำการอัพเดทโปรไฟล์ของคุณเรียบร้อยกรุณา login เพื่อเข้าใช้งานระบบอีกครั้ง',
            icon: 'success',
            didClose: ()=>{
              redirectToHome()
            }
        }).then(()=>{
            logout();
        })

      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login detail is incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Profile Details</h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-2 col-form-label required fw-bold fs-6'>ชื่อ-นามสกุล</label>

              <div className='col-lg-10'>
                <div className='row'>
                  <div className='col-lg-6 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                      placeholder='ชื่อ'
                      {...formik.getFieldProps('fName')}
                    />
                    {formik.touched.fName && formik.errors.fName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.fName}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-lg-6 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='นามสกุล'
                      {...formik.getFieldProps('lName')}
                    />
                    {formik.touched.lName && formik.errors.lName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.lName}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-2 col-form-label required fw-bold fs-6'>อีเมล</label>

              <div className='col-lg-10 fv-row'>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  {...formik.getFieldProps('email')}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>{formik.errors.email}</div>
                  </div>
                )}
              </div>
            </div>

            {currentUser && <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
            <KTSVG
              path='icons/duotune/general/gen044.svg'
              className='svg-icon-2tx svg-icon-warning me-4'
            />
            <div className='d-flex flex-stack flex-grow-1'>
              <div className='d-flex align-items-center py-1'>
                <div className='symbol symbol-35px me-2'>
                  <img
                    alt='key'
                    src={toAbsoluteUrl('/media/custom/key.png')}
                    className='d-none d-lg-inline w-50px theme-light-show'
                  />
                </div>

                <div className='d-flex flex-column align-items-start justify-content-center'>
                  <div className='fw-bold'>
                    <h4 className='text-gray-800 fw-bolder'>ต้องการแก้เปลี่ยนรหัสผ่านใหม่?</h4>
                    <div className='fs-6 text-gray-600'>
                      <Link className='fw-bolder' to={'/home/password_reset?reset='+encoded_id}>
                        {' '}
                        คลิกเพื่อเปลี่ยนรหัสผ่านในการเข้าระบบใหม่
                      </Link>
                      .
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
          
          </div>

          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button type='submit' className='btn btn-primary' disabled={loading || !currentUser}>
              {!loading && 'บันทึก'}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export {ProfileDetails}
